<template>
  <ul class="footer">
    <li>
      <a
        class="footer__link"
        target="_blank"
        href="https://privacypolicy.pg.com/en-IN/"
        >Privacy</a
      >
    </li>
    <li>
      <router-link
        class="footer__link"
        target="_blank"
        to="/terms-and-conditions"
        >Terms & Conditions</router-link
      >
    </li>

    <li>
      <a
        class="flex items-center footer__link"
        target="_blank"
        href="https://privacypolicy.pg.com"
      >
        <span>
          <img
            src="@/assets/images/a-c.png"
            alt="Ad choices"
            style="width: 7px"
            class="mr-1"
          />
        </span>
        AdChoices
      </a>
    </li>
    <li>
      <a
        class="flex items-center footer__link"
        target="_blank"
        href="https://preferencecenter.pg.com/en-in/"
      >
        Your Privacy Choices
        <span>
          <img
            src="@/assets/images/privacy.svg"
            alt="Your Privacy Choices"
            style="width: 7px"
            class="mr-1"
          />
        </span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Footer',
}
</script>
<style lang="postcss" scoped>
.footer {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px 20px;
  width: 100%;
  padding: 10px 15px;
  text-align: center;

  &__link {
    color: #3298d5;
    font-size: 12px;
  }
}
</style>
